"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Scrim =
/*#__PURE__*/
function (_Component) {
  _inherits(Scrim, _Component);

  function Scrim(props) {
    var _this;

    _classCallCheck(this, Scrim);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scrim).call(this, props));
    _this.state = {
      animationClass: '',
      destroy: !props.show
    };
    return _this;
  }

  _createClass(Scrim, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.show) {
        this.fadeIn();
      }
    }
  }, {
    key: "fadeIn",
    value: function fadeIn() {
      var _this2 = this;

      this.setState({
        destroy: false
      }, function () {
        _this2.setState({
          animationClass: 'dqpl-scrim-show'
        }); // using setTimeout because css transitions require us to add the classes separately


        setTimeout(function () {
          if (!_this2.el) {
            return;
          }

          _this2.setState({
            animationClass: 'dqpl-scrim-show dqpl-scrim-fade-in'
          });
        });
      });
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      var _this3 = this;

      this.setState({
        animationClass: 'dqpl-scrim-show'
      }, function () {
        // using setTimeout because css transitions require us to add the classes separately
        setTimeout(function () {
          _this3.setState({
            animationClass: ''
          }, function () {
            _this3.setState({
              destroy: true
            });
          });
        }, 100);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var show = this.props.show;
      var changed = typeof show !== 'undefined' && prevProps.show !== show;

      if (changed) {
        if (!prevProps.show) {
          return this.fadeIn();
        }

        this.fadeOut();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state = this.state,
          animationClass = _this$state.animationClass,
          destroy = _this$state.destroy;

      if (destroy) {
        return null;
      }

      return _react["default"].createElement("div", {
        ref: function ref(el) {
          return _this4.el = el;
        },
        className: "dqpl-scrim ".concat(animationClass)
      });
    }
  }]);

  return Scrim;
}(_react.Component);

exports["default"] = Scrim;
Scrim.propTypes = {
  show: _propTypes["default"].bool.isRequired
};